var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('super-container-view',[_c('back'),_c('activation-form',{attrs:{"item":_vm.prime.activation,"context":_vm.prime.context,"options":_vm.prime.options}}),_c('request-button',{attrs:{"onClick":_vm.hiSave,"label":"Save"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }